import React, { useState, useId } from 'react';
import { ChevronDown } from 'lucide-react';
import { Box, Flex, Text } from '@chakra-ui/react';

const Accordion = ({ title, children, initialOpen = false }) => {
  const [isOpen, setIsOpen] = useState(initialOpen);
  const contentId = useId();

  return (
    <Box
      borderWidth="1px"
      borderColor="var(--border)"
      borderRadius="xl"
      overflow="hidden"
      bg="var(--surface)"
      mb={2}
      transition="box-shadow 200ms"
      _hover={{ boxShadow: '0 2px 12px rgba(27,79,204,0.06)' }}
      fontFamily="body"
    >
      <Flex
        as="button"
        w="full"
        align="center"
        justify="space-between"
        px={6}
        py={4}
        bg="transparent"
        border="none"
        cursor="pointer"
        textAlign="left"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-controls={contentId}
        aria-label={`${isOpen ? 'Collapse' : 'Expand'} ${title}`}
        _hover={{ bg: 'var(--surface-alt)' }}
        transition="background 150ms"
      >
        <Text fontSize="sm" fontWeight="600" color="var(--text-main)" flex={1} pr={4}>
          {title}
        </Text>
        <Box
          flexShrink={0}
          color="brand.600"
          transition="transform 200ms"
          style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
        >
          <ChevronDown size={18} aria-hidden="true" />
        </Box>
      </Flex>
      <Box
        id={contentId}
        aria-hidden={!isOpen}
        role="region"
        overflow="hidden"
        maxH={isOpen ? '500px' : '0'}
        transition="max-height 300ms ease"
      >
        <Box px={6} pb={5} pt={0}>
          <Box
            px={4}
            py={4}
            borderRadius="lg"
            bg="brand.subtle"
            borderWidth="1px"
            borderColor="landing.border"
          >
            <Text fontSize="sm" color="text.secondary" lineHeight="1.75">
              {children}
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Accordion;
